module.exports = __webpack_public_path__ + "static/media/icon-upload-blue.dbda1972.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/icon-upload-blue.svg
// module id = 351
// module chunks = 0